import Dexie from 'dexie';
import { UserMetaData } from '../../redux/auth/authTypes';
import { decryptPrivateKey } from '../../cryptor/keyPairCrypto';
import { ResultWithOptionalError } from '../../types/generic/results';

const dbName = 'Users';

enum UsersStore {
  Users = 'U',
  Handlers = 'H',
  PublicKeys = 'P',
  PrivateKeys = 'Pr',
}

enum HandlersKey {
  Backup = 'B',
}

const usersStoreSchema = Object.values(UsersStore).reduce((store, key) => {
  store[key] = '++';
  return store;
}, {} as { [key: string]: string });

const getDB = async () => {
  const db = new Dexie(dbName);
  db.version(1).stores(usersStoreSchema);
  await db.open();

  return db;
};

export const fetchUsersList = async (): Promise<
  ResultWithOptionalError<UserMetaData[]>
> => {
  try {
    const db = await getDB();
    const users: UserMetaData[] = (
      await db.table(UsersStore.Users).orderBy(':id').toArray()
    ).map((user: string) => JSON.parse(user));

    db.close();
    return {
      data: users,
    };
    // return users;
  } catch (error) {
    return {
      error: new Error(error as string),
    };
    // throw error;

    //new Err(error)
  }
};

export const saveUser = async (
  user: UserMetaData,
  encPrivateKey: string,
  publicKey: CryptoKey
): Promise<ResultWithOptionalError<boolean>> => {
  try {
    const db = await getDB();

    await db.table(UsersStore.PublicKeys).put(publicKey, user.id);
    await db.table(UsersStore.PrivateKeys).put(encPrivateKey, user.id);
    await db.table(UsersStore.Users).put(JSON.stringify(user), user.id);

    db.close();
    return {
      data: true,
    };
    // return new Ok(true);
  } catch (error) {
    return {
      error: new Error(error as string),
    };
  }
};

export const getUserMetaData = async (
  userId: string
): Promise<ResultWithOptionalError<UserMetaData>> => {
  try {
    const db = await getDB();

    const str: string = await db.table(UsersStore.Users).get(userId);
    const user: UserMetaData = JSON.parse(str);
    ('User not Found');
    db.close();
    if (!user)
      return {
        error: new Error('User not Found'),
      };
    return {
      data: user,
    };
  } catch (error) {
    console.log(error);
    return {
      error: new Error(error as string),
    };
  }
};

export const updateUserMetaData = async (
  user: UserMetaData
): Promise<ResultWithOptionalError<boolean>> => {
  try {
    const db = await getDB();

    await db.table(UsersStore.Users).put(user, user.id);

    db.close();
    return {
      data: true,
    };
    // return new Ok(true);
  } catch (error) {
    return {
      error: new Error(error as string),
    };
  }
};

// export const getUserWithKeys = async (
//   userId: string
// ): Promise<ResultWithOptionalError<UserWithKeys>> => {
//   try {
//     const db = await getDB();

//     const str: string | undefined = await db
//       .table(UsersStore.Users)
//       .get(userId);
//     const user: UserMetaData | null = str ? JSON.parse(str) : null;

//     const encPrivateKey: string | undefined = await db
//       .table(UsersStore.PrivateKeys)
//       .get(userId);
//     const publicKey: CryptoKey | undefined = await db
//       .table(UsersStore.PublicKeys)
//       .get(userId);

//     const encFeKey = await getUserEncFeKey(userId);

//     db.close();

//     if (!user || !encPrivateKey || !publicKey) {
//       return {
//         error: new Error('User data is missing'),
//       };
//     }

//     return {
//       data: {
//         userMetaData: user,
//         encFeKey,
//         encPrivateKey,
//         publicKey,
//       },
//     };
//   } catch (error) {
//     return {
//       error: new Error(error as string),
//     };
//   }
// };

export const getUserPublicKey = async (userId: string): Promise<ResultWithOptionalError<CryptoKey>> => {
  try {
    const db = await getDB()

    const publicKey: CryptoKey | undefined = await db.table(UsersStore.PublicKeys).get(userId)

    db.close()

    if(!publicKey) return { error: new Error("Public key not found") }

    return {
      data: publicKey
    }
  } catch(err) {
    return { error: new Error("Public key not found") }
  }
}

export const validateUserPassKey = async (
  userId: string,
  passKey: string
): Promise<ResultWithOptionalError<CryptoKey>> => {
  try {
    const db = await getDB();

    const encPrivateKey: string | undefined = await db
      .table(UsersStore.PrivateKeys)
      .get(userId);

    db.close();

    if (!encPrivateKey) {
      return {
        error: new Error('Private key not found')
      }
    }

    const { error, privateKey } = await decryptPrivateKey(
      encPrivateKey,
      passKey
    );
    if (error || !privateKey) {
      return {
        error: new Error(error as string),
      };
    }
    return {
      data: privateKey,
    };
  } catch (error) {
    return {
      error: new Error(error as string),
    };
  }
};

export const saveDirectoryHandler = async (
  directoryHandler: FileSystemDirectoryHandle
): Promise<ResultWithOptionalError<boolean>> => {
  try {
    const db = await getDB();

    await db
      .table(UsersStore.Handlers)
      .put(directoryHandler, HandlersKey.Backup);

    db.close();

    return { data: true };
  } catch (error) {
    return {
      error: new Error('Error saving directory handler'),
    };
  }
};

export const getDirectoryHandler = async (): Promise<
  ResultWithOptionalError<FileSystemDirectoryHandle>
> => {
  try {
    const db = await getDB();

    const dirHandler = await db
      .table(UsersStore.Handlers)
      .get(HandlersKey.Backup);
    db.close();

    if (dirHandler) return { data: dirHandler };
    return {
      error: new Error('No Handler Found'),
    };
  } catch (err) {
    return {
      error: new Error(err as string),
    };
  }
};
